import ButtonIconT from '@components/tailwind-components/Button/ButtonIconT';
import { MAX_CALL_TO_ACTION_ITEMS_COUNT } from '@conversed/shared/src/central/constants/boundaries';
import type React from 'react';
import { type Control, useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { TFacebookSettings } from '../../../../../interfaces/TFacebook';
import FacebookCallToAction from './FacebookCallToAction';

type Props = {
  name: string;
  control: Control<TFacebookSettings>;
};

export const FacebookCallToActionList: React.FC<Props> = ({
  name,
  control,
}) => {
  const { t } = useTranslation();
  const { fields, append, remove } = useFieldArray({
    control,
    name: name as any,
  });
  return (
    <div className='flex gap-4 flex-col'>
      {fields.map((field, actionId) => (
        <div key={field.id} className='flex flex-col gap-2'>
          <FacebookCallToAction
            name={`${name}.${actionId}`}
            control={control}
          />
          {fields.length > 1 && (
            <ButtonIconT
              icon='delete'
              onClick={() => remove(actionId)}
              label={t('settings.facebook.persistent-menu.delete-action')}
              color='danger'
            />
          )}
        </div>
      ))}
      {fields.length < MAX_CALL_TO_ACTION_ITEMS_COUNT && (
        <ButtonIconT
          className='mb-3'
          icon='add_circle'
          onClick={() => append({})}
          label={t('settings.facebook.persistent-menu.add-action')}
          color='primary-base'
        />
      )}
    </div>
  );
};

export default FacebookCallToActionList;
